/**
 * EVO-263: topes de miniaturas por contexto y titulo por defecto del bloque de
 * colores asociados.
 *
 * Contrato CONFIRMADO contra la implementacion del edge: los cuatro campos son
 * de `StoreConfig` en Magento y el edge los reparte, como hace con todo el
 * storeConfig, en un grupo dentro de `config.base` — el mismo patron por el que
 * `enable_sales_units` / `label_text` / `last_units` llegan en
 * `config.base.sales_units`. Los nombres de los campos se mantienen tal cual:
 *
 *   StoreConfig.associated_products_plp_limit     ->
 *   StoreConfig.associated_products_srp_limit     ->  config.base
 *   StoreConfig.associated_products_pdp_limit     ->    .associated_products.*
 *   StoreConfig.associated_products_default_title ->
 *
 * Los limites llegan ya casteados a `Int` (en Magento viven como texto en
 * `core_config_data`). El grupo puede no venir si el modulo de Magento todavia
 * no esta deployado en el ambiente: en ese caso todo cae al tope por defecto
 * (`ASSOCIATED_PRODUCTS_FALLBACK_LIMIT`).
 */
export const associatedProductsConfigQuery = /* GraphQL */ `
    query getAssociatedProductsConfig {
        config {
            base {
                associated_products {
                    associated_products_plp_limit
                    associated_products_srp_limit
                    associated_products_pdp_limit
                    associated_products_default_title
                }
            }
        }
    }
`

export type AssociatedProductsConfigFields = {
    associated_products_plp_limit?: number | null
    associated_products_srp_limit?: number | null
    associated_products_pdp_limit?: number | null
    associated_products_default_title?: string | null
}

export type AssociatedProductsConfigOutput = {
    config?: {
        base?: {
            associated_products?: AssociatedProductsConfigFields | null
        } | null
    } | null
}
